import { Row, Col, Pagination, Spinner } from "react-bootstrap";
import BTable from "react-bootstrap/Table";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter
} from "react-table";
import { useNavigate } from "react-router-dom";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { useEffect, useState } from "react";
import { left, right } from "../assets/img";
import { useAppContext } from "../Services/AppContext";

export function CustomTable({
  columns,
  data,
  setPageno,
  loading = false,
  pagecount,
  show,
  pageno,
  color = "#000",
}) {
  const navigate = useNavigate();
  const [pagenumber, setPagenumber] = useState(pageno || 1);
  const { arrowEnable } = useAppContext();
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
    globalFilter,
    setGlobalFilter,

    page,
    pageCount,
    gotoPage,
    state: { pageIndex },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: (pageno ? pageno - 1 : 0), pageSize: 20 },
      manualPagination: true,
      pageCount: pagecount,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  // Sync local page number with table page index
  useEffect(() => {
    setPagenumber(pageIndex + 1);
  }, [pageIndex]);

  // Sync parent pageno change
  useEffect(() => {
    if (pageno) {
      gotoPage(pageno - 1);
      setPagenumber(pageno);
    }
  }, [pageno]);

  useEffect(() => {
//     console.log("saideBarShow in Table:", arrowEnable);
  }, [arrowEnable]);

  return (
    <div className="tablealign table-design">
      <BTable
        size="sm"
        responsive
        {...getTableProps()}
        className="table-border table mb-0"
        style={{ border: "1px solid #bcbcbc", borderCollapse: "separate", borderSpacing: 0 }}
      >
        <thead className="fixed-header">
          {headerGroups.map((headerGroup, ind) => (
            <tr {...headerGroup.getHeaderGroupProps()} key={ind}>
              {headerGroup.headers.map((column, indx) => (
                <th
                  className="px-2 text-center"
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  key={indx}
                  style={{
                    verticalAlign: "middle",
                    borderBottom: "1.5px solid #bcbcbc",
                    borderRight: "2px solid #d9d9d9",
                    backgroundClip: "padding-box",
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                  }}
                >
                  <h4 className="f3 fs-xs-14 fs-md-15 py-2 primary word-per-line">
                    {column.render("Header")}
                  </h4>
                  <span>
                    {column.isSorted ? (
                      column.isSortedDesc ? (
                        <span className="feather icon-arrow-down text-muted float-right" />
                      ) : (
                        <span className="feather icon-arrow-up text-muted float-right" />
                      )
                    ) : (
                      ""
                    )}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>



          {loading ? (
            <tr style={{ backgroundColor: '#f0ede6' }}>
              <td style={{ backgroundColor: '#f0ede6' }} colSpan={columns.length} className="text-center py-5">
                <Spinner animation="border" size="sm" /> &nbsp; Loading data...
              </td>
            </tr>
          ) : rows.length > 0 ? (
            page.map((row, i) => {
              prepareRow(row);
              return (
                <tr className="text-start f2" {...row.getRowProps()} key={i}>
                  {row.cells.map((cell, ind) => {
                    const isClickable = [
                      "id",
                      "client_id",
                      "name",
                      "mobile",
                    ].includes(cell.column.id);

                    return (
                      <td
                        style={{
                          borderTop: "1px solid #bcbcbc",
                          borderLeft: "none",
                          // borderBottom: "1px solid #bcbcbc", // added row bottom border for row lines
                          color: color,
                          cursor: isClickable ? "pointer" : "default",
                          // borderRight: "2px solid #bcbcbc",
                          verticalAlign: "middle",
                        }}
                        className="f3 fs-xs-14 fs-md-14 gray2 list-data"
                        {...cell.getCellProps()}
                        key={ind}
                        onClick={() => {
                          if (isClickable) {
                            const { ClientID, name, mobileno } = row.original;
//                             console.log({
//                               ClientID,
//                               name,
//                               mobileno,
//                             });

                            navigate("/client-report", { state: { type: "edit", data: row.original } });
                          }
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: cell.value === "Yes" ? "#209f58" : cell.value === "No" ? "#ff2929" : undefined,
                            borderRadius: (cell.value === "Yes" || cell.value === "No") ? "10px" : undefined,
                            textAlign: (cell.value === "Yes" || cell.value === "No") ? "center" : "left",
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          {cell.render("Cell")}
                        </div>
                      </td>
                    );
                  })}
                </tr>
              );
            })
          ) : (
            // ❌ No data found
            <tr style={{ backgroundColor: '#f0ede6' }}>
              <td colSpan={columns.length} className="text-center py-5 text-muted">
                No data found
              </td>
            </tr>
          )}
        </tbody>
      </BTable>

      {show && (
        <Row style={{ zIndex: 999, width: !arrowEnable ? '100%' : '' }} className="justify-content-between table-show p-2  bg-primary2">
          <Col className="d-flex ac-jb w-100 px-2 pagination_box">
            <p className="px-1 mb-0 f3">Total Pages {pagecount || 0}</p>

            <Pagination className="gap-1 pointer mb-0 d-flex ac-js">

              {/* LEFT ARROW */}
              {pagenumber > 1 && (
                <img
                  src={left}
                  width={20}
                  height={22}
                  alt=""
                  onClick={() => {
                    if (pagenumber > 1) {
                      const newPage = pagenumber - 1;
                      setPagenumber(newPage);
                      setPageno(newPage); // API CALL
                    }
                  }}
                />
              )}

              {/* PAGE INPUT */}
              <input
                type="number"
                style={{ width: "28px", height: "25px", minWidth: "28px" }}
                className="form-control1 ml-2 p-1 text-center placholdercolorchanges2"
                value={pagenumber}
                min={1}
                max={pagecount}

                onFocus={(e) => {
                  // ✅ Select all text when focused
                  e.target.select();
                }}

                onChange={(e) => {
                  const value = e.target.value;

                  // ✅ Allow clearing with backspace (when selected)
                  if (value === "") {
                    setPagenumber("");
                    return;
                  }

                  let val = Number(value);
                  if (isNaN(val)) return;

                  // Clamp between 1 and pagecount
                  if (val < 1) val = 1;
                  if (val > pagecount) val = pagecount;

                  setPagenumber(val);
                  setPageno(val);       // API call
                  gotoPage(val - 1);
                }}

                onBlur={() => {
                  // ✅ Reset if left empty
                  if (pagenumber === "") {
                    setPagenumber(1);
                    setPageno(1);
                    gotoPage(0);
                  }
                }}
              />


              {/* RIGHT ARROW */}
              {pagenumber < pagecount && (
                <img
                  src={right}
                  width={20}
                  height={22}
                  alt=""
                  onClick={() => {
                    if (pagenumber < pagecount) {
                      const newPage = pagenumber + 1;
                      setPagenumber(newPage);
                      setPageno(newPage); // API CALL
                    }
                  }}
                />
              )}
            </Pagination>
          </Col>
        </Row>
      )}
    </div>
  );
}
